const KomponenUtama: React.FC = () => {
    return (
        <div className="text-justify py-4">
            <h2 className="text-lg font-semibold mb-3">🧩 5 Komponen Utama yang Menyusun Sebuah Robot</h2>

            <p className="mb-4">
                Robot bukan sekadar kotak dengan roda yang bisa bergerak. Di balik setiap gerakan dan respons robot, ada sistem kompleks yang terdiri dari berbagai komponen utama—masing-masing memiliki peran penting, seperti organ tubuh manusia yang bekerja sama. Yuk, kenali satu per satu komponen vital yang membentuk sebuah robot! 👇
            </p>

            <ul className="space-y-4 mb-6">
                <li>
                    <strong>👁️ Sensor</strong> – <em>Mata dan telinga robot</em>.<br />
                    Sensor memungkinkan robot merasakan dunia di sekitarnya. Tanpa sensor, robot tak bisa mendeteksi dinding, cahaya, suhu, atau bahkan keberadaan manusia. Jenis-jenis sensor meliputi:
                    <ul className="list-disc list-inside ml-5 mt-1">
                        <li>📏 Sensor jarak (ultrasonik, infrared)</li>
                        <li>🌡️ Sensor suhu</li>
                        <li>💡 Sensor cahaya (LDR)</li>
                        <li>🔄 Sensor gerak atau rotasi (gyroscope, accelerometer)</li>
                    </ul>
                    Sensor mengubah informasi fisik menjadi data digital yang dapat diproses oleh otak robot.
                </li>

                <li>
                    <strong>💪 Aktuator</strong> – <em>Otot robot</em>.<br />
                    Aktuator adalah komponen yang mengubah sinyal listrik menjadi gerakan fisik. Contoh aktuator:
                    <ul className="list-disc list-inside ml-5 mt-1">
                        <li>⚙️ Motor DC – untuk gerakan memutar roda</li>
                        <li>🔁 Servo – untuk posisi presisi seperti pada lengan robot</li>
                        <li>📏 Linear actuator – untuk gerakan maju-mundur</li>
                    </ul>
                    Aktuator ini digerakkan berdasarkan perintah dari kontroler untuk melakukan tugas tertentu seperti berjalan, mengangkat benda, atau menunjuk arah.
                </li>

                <li>
                    <strong>🧠 Kontroler</strong> – <em>Otak robot</em>.<br />
                    Komponen ini adalah pusat pengambilan keputusan dalam robot. Kontroler membaca data dari sensor, menjalankan logika program, lalu mengirim perintah ke aktuator. Contoh kontroler:
                    <ul className="list-disc list-inside ml-5 mt-1">
                        <li>🔌 Arduino – populer untuk proyek robotik pemula</li>
                        <li>📦 Raspberry Pi – lebih canggih, mendukung sistem operasi dan pemrosesan gambar</li>
                        <li>🔧 ESP32 – kontroler kecil dengan WiFi/Bluetooth</li>
                    </ul>
                    Di sinilah kamu menulis program untuk mengatur perilaku robotmu.
                </li>

                <li>
                    <strong>🦾 Struktur Mekanik</strong> – <em>Tubuh dan rangka robot</em>.<br />
                    Struktur ini menahan dan menyatukan semua komponen robot. Rangkanya harus cukup kuat untuk menopang berat sensor dan motor, tetapi juga cukup ringan agar mudah bergerak. Material umum:
                    <ul className="list-disc list-inside ml-5 mt-1">
                        <li>🧱 Plastik ABS – ringan dan mudah dipotong</li>
                        <li>🔩 Aluminium – kuat dan ringan, cocok untuk lengan robot</li>
                        <li>🧬 Material cetak 3D – fleksibel untuk desain khusus</li>
                    </ul>
                    Desain mekanik juga menentukan efisiensi dan stabilitas gerak robot.
                </li>

                <li>
                    <strong>🔋 Power Supply</strong> – <em>Jantung energi robot</em>.<br />
                    Semua komponen elektronik dalam robot butuh daya. Sumber daya ini harus stabil dan sesuai dengan kebutuhan voltase dan arus. Contoh:
                    <ul className="list-disc list-inside ml-5 mt-1">
                        <li>🔋 Baterai Li-ion – umum dipakai untuk daya portabel</li>
                        <li>🔌 Adaptor DC – cocok untuk robot stasioner</li>
                        <li>🔋 Power bank – bisa digunakan untuk Raspberry Pi atau mikrokontroler</li>
                    </ul>
                    Tanpa suplai daya yang baik, robot akan cepat mati atau tidak stabil.
                </li>
            </ul>

            <p className="text-gray-700">
                Kelima komponen ini harus saling terhubung dan bekerja secara sinergis agar robot bisa menjalankan tugasnya dengan efektif. Memahami struktur dasar ini penting bagi siapa pun yang ingin mulai merakit atau merancang robot. Tidak perlu langsung membuat robot canggih—mulailah dari yang sederhana dan pelajari setiap bagiannya. Siap membangun robot pertamamu? 🚀
            </p>

        </div>
    )
}
export default KomponenUtama